import { CONST_ROWS_PER_PAGE } from '@commons/consts';
import {
    NEW_FUNCIONARIO_CADASTRO_SUCCESS,
    CANCEL_FUNCIONARIO_CADASTRO_RAPIDO_SUCCESS,
    TABLE_FUNCIONARIO_CADASTRO_PENDING,
    TABLE_FUNCIONARIO_CADASTRO_SUCCESS,
    TABLE_FUNCIONARIO_CADASTRO_FAILURE,
    LIST_FUNCIONARIO_CADASTRO_PENDING,
    LIST_FUNCIONARIO_CADASTRO_SUCCESS,
    LIST_FUNCIONARIO_CADASTRO_FAILURE,
    FIND_FUNCIONARIO_CADASTRO_PENDING,
    FIND_FUNCIONARIO_CADASTRO_SUCCESS,
    FIND_FUNCIONARIO_CADASTRO_FAILURE,
    DELETE_FUNCIONARIO_CADASTRO_PENDING,
    DELETE_FUNCIONARIO_CADASTRO_SUCCESS,
    DELETE_FUNCIONARIO_CADASTRO_FAILURE,
    CREATE_FUNCIONARIO_CADASTRO_PENDING,
    CREATE_FUNCIONARIO_CADASTRO_SUCCESS,
    CREATE_FUNCIONARIO_CADASTRO_FAILURE,
    NEW_FILTER_FUNCIONARIO_CADASTRO_PENDING,
    NEW_FILTER_FUNCIONARIO_CADASTRO_SUCCESS,
    NEW_FILTER_FUNCIONARIO_CADASTRO_FAILURE,
    NEW_FILTER_NEXT_PAGE_FUNCIONARIO_CADASTRO_PENDING,
    NEW_FILTER_NEXT_PAGE_FUNCIONARIO_CADASTRO_SUCCESS,
    NEW_FILTER_NEXT_PAGE_FUNCIONARIO_CADASTRO_FAILURE,
} from './actionTypes';

const initialState = {
  list: null,
  loading: false,
  filter: {
    rows: CONST_ROWS_PER_PAGE,
    page: 0,
    where: '',
  },
};

function funcionarioCadastroReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_FUNCIONARIO_CADASTRO_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: action.isCadastroRapido ?? false,
            }
        case LIST_FUNCIONARIO_CADASTRO_PENDING:
        case FIND_FUNCIONARIO_CADASTRO_PENDING:
        case DELETE_FUNCIONARIO_CADASTRO_PENDING:
        case CREATE_FUNCIONARIO_CADASTRO_PENDING:
        case TABLE_FUNCIONARIO_CADASTRO_PENDING:
        case NEW_FILTER_FUNCIONARIO_CADASTRO_PENDING:
        case NEW_FILTER_NEXT_PAGE_FUNCIONARIO_CADASTRO_PENDING:   
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CANCEL_FUNCIONARIO_CADASTRO_RAPIDO_SUCCESS:
            return {
                ...state,
                isCadastroRapido: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case LIST_FUNCIONARIO_CADASTRO_SUCCESS:
            return {
                ...state,
                list: action.list,
                loading: false
            }
        case LIST_FUNCIONARIO_CADASTRO_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case TABLE_FUNCIONARIO_CADASTRO_SUCCESS:
            return {
                ...state,
                table: action.table,
                loading: false
            }
        case TABLE_FUNCIONARIO_CADASTRO_FAILURE:
            return {
                ...state,
                table: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_FUNCIONARIO_CADASTRO_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_FUNCIONARIO_CADASTRO_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_FUNCIONARIO_CADASTRO_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_FUNCIONARIO_CADASTRO_SUCCESS:
        case CREATE_FUNCIONARIO_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: false,
            }
        case DELETE_FUNCIONARIO_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case NEW_FILTER_FUNCIONARIO_CADASTRO_SUCCESS:
            return {
                ...state,
                list: action.list,
                filter: action.filter,
                loading: false
            }
        case NEW_FILTER_FUNCIONARIO_CADASTRO_FAILURE: {
            return {
                ...state,
                loading: false
            }
        }
        case NEW_FILTER_NEXT_PAGE_FUNCIONARIO_CADASTRO_SUCCESS:
            return {
                ...state,
                list: action.list,
                filter: action.filter,
                loading: false
            }
        case NEW_FILTER_NEXT_PAGE_FUNCIONARIO_CADASTRO_FAILURE: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { funcionarioCadastroReducer };